
  $(document).ready(function(){
    var slideshow_id = ".custom-blog-slider";
    var autoplay,autoplayspeed,arrows,dots;
    var Slideshow_autoplay = $(slideshow_id).attr('slideshow-autoplay');
    var slideshow_style = $(slideshow_id).attr('slider_Style');
    if(slideshow_style == 'arrows' ){
      var arrows = true;
    }else{
      var arrows = false;
    }
    if(slideshow_style == 'dots' || slideshow_style == 'bars'){
      var dots = true;
    }else{
      var dots = false;
    }
    if(slideshow_style == 'minimal'){
      var dots = true;
      var arrows = false;
    }
    if(Slideshow_autoplay == 'true'){
      var autoplay = true;
      var autoplayspeed = ($(slideshow_id).attr('slideshow-autoplay_speed')) * 1000;
    }else{
      var autoplay = false;
    }
    $(slideshow_id).slick({
      autoplay: autoplay,
      autoplaySpeed: autoplayspeed,
      
        slidesToShow: 5,
        slidesToScroll: 5,

      arrows:arrows,
      dots:dots,
      adaptiveHeight:true,
        responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
    });
  })
